import { useLang } from '@/i18n';
import css from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import { IPageStatus } from '../../config/IPageStatus';
import { useProductState } from '../../ProductProvider';
import { ItfItem, ItfList } from './type';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar } from 'swiper';
import { Swiper as ItfSwiper } from 'swiper/types';
import { useEffect, useState } from 'react';
import gtm from 'eco-design-reliance/gtm';

const H: React.FC = () => {
    const { pageStatus } = useProductState();
    const IS_STAGE_1 = pageStatus === IPageStatus.STAGE_1;
    const { t } = useLang(`ces2026.H.${IS_STAGE_1 ? 'stage1' : 'stage2'}`);
    const [swiper, setSwiper] = useState<ItfSwiper | null>(null);
    const [viewMore, setViewMore] = useState<boolean>(false);
    const [btnEnter, setBtnEnter] = useState<boolean>(false);

    const items: ItfItem[] = [
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1765415981090/H1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1765415980902/H1_m.jpg'],
            name: t('item1_name'),
            time: t('item1_time'),
            text: t('item1_text'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1765415981476/H2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1765415981277/H2_m.png'],
            name: t('item2_name'),
            time: t('item2_time'),
            text: t('item2_text'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1766192444872/H3.jpg', 'https://websiteoss.ecoflow.com/upload/image/1766192444655/H3_m.jpg'],
            name: t('item3_name'),
            time: t('item3_time'),
            text: t('item3_text'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1766192445371/H4.jpg', 'https://websiteoss.ecoflow.com/upload/image/1766192445129/H4_m.jpg'],
            name: t('item4_name'),
            time: t('item4_time'),
            text: t('item4_text'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1766124010855/H5.jpg', 'https://websiteoss.ecoflow.com/upload/image/1766130357311/H5_m.jpg'],
            name: t('item5_name'),
            time: t('item5_time'),
            text: t('item5_text'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1766192445848/H6.jpg', 'https://websiteoss.ecoflow.com/upload/image/1766192445611/H6_m.jpg'],
            name: t('item6_name'),
            time: t('item6_time'),
            text: t('item6_text'),
        },
    ];

    const lists: ItfList[] = [
        {
            img: '',
            text: t('item1_text'),
        },
        {
            img: '',
            text: t('item2_text'),
        },
        {
            img: '',
            text: t('item3_text'),
        },
        {
            img: '',
            text: t('item4_text'),
        },
        {
            img: '',
            text: t('item5_text'),
        },
        {
            img: '',
            text: t('item6_text'),
        },
        {
            img: '',
            text: t('item7_text'),
        },
        {
            img: '',
            text: t('item8_text'),
        },
    ];

    const handleView = () => {
        setViewMore(!viewMore);
        gtm.push({
            __btn_id1: 'ces-2026-H',
            __btn_id2: viewMore ? t('btn_view_less') : t('btn_view_more'),
            __btn_type: 'common',
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined' && swiper) {
            swiper.allowTouchMove = window.innerWidth <= 1024;
        }
    }, [swiper]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const scenes: any[] = [];
            const el: HTMLDivElement | null = document.querySelector('.ces-2026-G');
            if (el) {
                scenes.push(
                    AniContainer.create({
                        triggerElement: el,
                        triggerHook: 1,
                        offset: el.offsetHeight,
                        duration: '50%',
                        syncFromTo: [
                            ['.ces-2026-H', { y: window.innerHeight / 2 }, { y: 0 }],
                            // ['.ces-2026-G .box2', { opacity: 1 }, { opacity: 0 }],
                        ],
                    }),
                );
            }
            if (!IS_STAGE_1) {
                lists?.map((_: ItfList, i: number) => {
                    const target: HTMLUListElement | null = document.querySelector(`.ces-2026-H .list-${i + 1}`);
                    if (target) {
                        scenes.push(
                            AniContainer.create({
                                triggerElement: target,
                                triggerHook: 1,
                                offset: target.offsetHeight,
                                duration: '25%',
                                asyncFromTo: [
                                    [`.ces-2026-H .list-${i + 1} .list-img`, { y: 200, opacity: 0 }, { y: 0, opacity: 1 }, 0.75],
                                    [`.ces-2026-H .list-${i + 1} .list-text`, { y: 120, opacity: 0 }, { y: 0, opacity: 1 }, 0.25],
                                ],
                                asyncTimeLines: [0, 0.75],
                            }),
                        );
                    }
                });
                if (window.innerWidth < 768) {
                    scenes.push(
                        AniContainer.create({
                            triggerElement: '.ces-2026-H .list-btn',
                            triggerHook: 1,
                            offset: 80,
                            duration: '100%',
                            onEnter: () => setBtnEnter(true),
                            onLeave: () => setBtnEnter(false),
                        }),
                    );
                }
            }
            return () => scenes?.forEach((scene: any) => scene && scene?.destroy());
        }
    }, [IS_STAGE_1]);

    return (
        <div id="ces-2026-H" className={`ces-2026-H ${css.section} GtmModuleData-section`} data-section-id={'ces-2026-H'}>
            <div className="info">
                <p className="title">{t('title')}</p>
            </div>
            {IS_STAGE_1 ? (
                <Swiper
                    className="items"
                    slidesPerView={'auto'}
                    spaceBetween={12}
                    modules={[Scrollbar]}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 60,
                        snapOnRelease: true,
                    }}
                    onSwiper={(ins: ItfSwiper) => setSwiper(ins)}
                >
                    {items?.map((item: ItfItem, i: number) => (
                        <SwiperSlide className="item" key={i}>
                            <div className="item-img">
                                <EcoImg pc={item.img[0]} h5={item.img[1]} />
                            </div>
                            <div className="item-info">
                                <p className="item-name name">{item.name}</p>
                                <p className="item-time text">{item.time}</p>
                                <p className="item-text text">{item.text}</p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            ) : (
                <>
                    <ul className={`lists ${viewMore ? 'more' : 'less'}`}>
                        {lists?.map((list: ItfList, i: number) => (
                            <li className={`list list-${i + 1}`} key={i} style={{ gridArea: `g${i + 1}` }}>
                                <div className="list-img">
                                    <EcoImg pc={list.img || 'https://websiteoss.ecoflow.com/upload/image/1766192444872/H3.jpg'} />
                                    <p className="list-text">{list.text}</p>
                                </div>
                            </li>
                        ))}
                        <button
                            className={`list-btn GtmModuleData-btn-common${btnEnter ? ' enter' : ''}`}
                            data-btn-id={viewMore ? t('btn_view_less') : t('btn_view_more')}
                            onClick={handleView}
                        >
                            <span className="btn-text">{viewMore ? t('btn_view_less') : t('btn_view_more')}</span>
                            <svg
                                className={`btn-svg ${viewMore ? 'more' : 'less'}`}
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                            >
                                <path
                                    d="M10.1543 4.30762L6.1543 8.30762L2.1543 4.30762"
                                    stroke="white"
                                    stroke-width="1.2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </button>
                    </ul>
                </>
            )}
        </div>
    );
};

export default H;
